export const LOCATION_ONBOARDING_STATUS = 'location_onboarding_status';
export const DEFAULT_VAL = 'default_val';
export const ACCEPTED = 'accepted';
export const UNACCEPTED = 'unaccepted';
export const DEPRECATED_LOCATION_ONBOARDING_STATUS = 'is_location_onboarded';

